import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { PaymentsApi, PostRequisitesRequest, PostRequisitesResponse } from '@shared/api/rest/payments';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface PostRequisitesType {
  data?: PostRequisitesResponse;
  loading: boolean;
  error: string | null;
  success: boolean | null;
  post: (request: PostRequisitesRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const usePostRequisitesStore = create<PostRequisitesType>((set) => ({
  data: undefined,
  loading: false,
  error: null,
  success: null,

  post: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, error: null, success: null });
      const result = await PaymentsApi.postRequisites(request, signal);
      set({ data: result?.data ?? [], loading: false, success: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: undefined, loading: false, error: null, success: null }),
}));
